module.exports = __webpack_public_path__ + "static/the-future-of-capitalism-943ee94071e81d1d2d8417aea1fa49bd.jpg";